import { createStore } from "redux";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

const initialState = {
  sidebarShow: true,
  authUser: false,
  dataUser: [],
  correosPendientes: 0,
  countPQRS: 0,
  tokenExpiresIn: "",
};

const persistConfig = {
  key: "root", // La clave utilizada para almacenar el estado en el almacenamiento
  storage, // El motor de almacenamiento a utilizar
  // Opcional: puedes configurar otras opciones de persistencia aquí, como "whitelist" o "blacklist"
};

const changeState = (state = initialState, { type, ...rest }) => {
  switch (type) {
    case "set":
      return { ...state, ...rest };
    case "setCorreosPendientes":
      return { ...state, correosPendientes: rest.correosPendientes };
    case "setcountPQRS":
      return { ...state, countPQRS: rest.countPQRS };
    default:
      return state;
  }
};

const persistedReducer = persistReducer(persistConfig, changeState);

const store = createStore(persistedReducer);
const persistor = persistStore(store);

export { store, persistor };
